import React from "react";
import { Box, Button, Typography, IconButton } from "@mui/material";
import { FormProvider, Controller } from "react-hook-form";
import { ChevronBigLeft } from "@tiny/icons";
import useAssignedToAudienceForm from "./AssignedToAudienceForm.hooks";
import AudienceSelector from "../TriggerForm/SelectRules/AudienceSelector/AudienceSelector";

interface AssignedToAudienceFormProps {
  id: string;
}

const AssignedToAudienceForm: React.FC<AssignedToAudienceFormProps> = ({
  id,
}) => {
  const {
    methods,
    control,
    onSubmit,
    handleCancel,
    saveDisabled,
    viewMode,
    audiences,
    handleAudienceSearch,
    loadMoreAudiences,
    isLoadingMore,
    hasMoreResults,
    isLoading,
    isTinyEmail,
  } = useAssignedToAudienceForm({ id });

  return (
    <FormProvider {...methods}>
      <form onSubmit={onSubmit} style={{ height: "100%" }}>
        <Box
          sx={{
            py: 4,
            px: 6,
            display: "flex",
            flexDirection: "column",
            width: { xs: "320px", xl: "20vw" },
            justifyContent: "space-between",
            height: "100%",
          }}
        >
          {/* Header */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <IconButton sx={{ px: 0 }} onClick={handleCancel}>
              <ChevronBigLeft color="success" />
            </IconButton>
            <Typography variant="h2">Add To Audience</Typography>
          </Box>

          {/* Form Content */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 5,
              mt: 6,
              flex: 1,
            }}
          >
            <Controller
              name="segment_ids"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value } }) => (
                <AudienceSelector
                  value={(value as any) || []}
                  onChange={onChange}
                  options={audiences}
                  onInputChange={handleAudienceSearch}
                  isLoading={isLoadingMore || isLoading}
                  hasMore={hasMoreResults}
                  onScrollEnd={loadMoreAudiences}
                  placeholder="Search Audience"
                  label="Audience"
                  enableInfiniteScroll={isTinyEmail}
                />
              )}
            />
          </Box>

          {/* Footer Buttons */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              p: 2,
            }}
          >
            <Button onClick={handleCancel}>Cancel</Button>
            <Button
              variant="contained"
              type="submit"
              disabled={saveDisabled || viewMode}
            >
              Save
            </Button>
          </Box>
        </Box>
      </form>
    </FormProvider>
  );
};

export default AssignedToAudienceForm;
